import "./styles.scss";
import React, { Component } from "react";
import { connect, ConnectedProps } from "react-redux";
import { FormattedMessage } from "react-intl";
import BracedTitle from "../../../../common/components/bracedTitle";
import ClientSettingsAPI from "../../apis/clientSettings.api";
import UserAPI from "../../../../authentication/apis/user.api";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import Input from "@material-ui/core/Input";
import { ProfilePart } from "../../enums/profilePart.enum";
import { IReducerState } from "../../../../reducer/interfaces/reducer.interface";
import ContactRole from "./contactRole";
import { Contact } from "../../models/contact.model";
import { User } from "../../../../authentication/models/user.model";
import Loader from "../../../../common/components/loader";
import AddCircleOutlinedIcon from "@material-ui/icons/AddCircleOutlined";
import { IApplication } from "../../../apiApplications/interfaces/application.interface";
import ApiCredentialsContent from "./apiCredentialsContent";
import { ClientSecretRequest } from "../../models/clientSecretRequest.model";
import { ApplicationsSecretMapping } from "../../models/applicationsSecretMapping.model";
import { NewContactPlaceholder } from "../../constants/newContactPlaceholder.constant";
import DeleteProfilePopup from "../../../../header/components/profile/deleteProfilePopup";
import { Button, Modal } from "@material-ui/core";
import { FormField } from "../../../../common/submodules/form/models/form-field.model";
import Visibility from '@material-ui/icons/Visibility';
import { IInputAdditionalParams } from "../../../../common/submodules/form/interfaces/form.interface";
import FormUtils from "../../../../../utils/form.utils";
import { Form } from "../../../../common/submodules/form/models/form.model";
import {
  TFormInputId,
  EFieldType,
  AddNewUser,
  AddNewContact,
  FormSelectValue,
  UpdateWebhook
} from "../../../../common/submodules/form/enums/form.enum";
import { UserPostCreation } from "../../../../authentication/models/user.model";
import { HttpCode } from "../../../../common/enums/http-code.enum";
import { IToastAlert } from "../../../../common/submodules/toast/interfaces/toast-alert.interface";
import { ToastType } from "../../../../common/submodules/toast/enums/toast-type.enum";
import ToastAlert from "../../../../common/submodules/toast/components/toastAlert";
import { defaultToastAlert } from "../../../../common/submodules/toast/constants/default-toast-alert.constant";
import { statuses } from "../../constants/userStatus.constant";
import { roleTypes } from "../../../../crm/constants/crm.constant";
import { ApiKey, Basic, DeliveryChannel, OAuth2, SubscriberConfiguration } from "../../models/subscriberConfiguration.model";
import { authenticationType } from "../../constants/authenticationType.constant";
type PropsFromRedux = ConnectedProps<typeof connector>;
interface IProps extends PropsFromRedux {
  namePart: string;
  applications?: IApplication[] | undefined;
  subscriber?:SubscriberConfiguration | undefined;
}

interface IStates {
  partOpened: boolean;
  contactRole: string;
  listUsers: User[];
  listContacts: Contact[];
  clientSecretRequests: ClientSecretRequest[] | undefined;
  isDeleteProfilePopupVisible: boolean;
  isAddNewModalOpened: boolean;
  isAddNewUserModal:boolean;
  isUpdateModalOpened: boolean;
  isRegistartionApproved: boolean;
  isRegistrationRejected:boolean;
  selectedWebhook:undefined | DeliveryChannel;
  form: Form;
  userSelected: User | undefined;
  contactSelected: Contact | undefined;
  isModalOpened: boolean;
  isRegisterLoading: boolean;
  toast: IToastAlert;
  isRemoveModalOpened: boolean;
  webhookForm:Form;
  showPassword:boolean;
}

class PartContent extends Component<IProps, IStates> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      partOpened: false,
      contactRole: "",
      listUsers: [],
      listContacts: [],
      clientSecretRequests: undefined,
      isDeleteProfilePopupVisible: false,
      isUpdateModalOpened: false,
      isModalOpened: false,
      isAddNewModalOpened: false,
      isAddNewUserModal:false,
      isRegistartionApproved: false,
      isRegistrationRejected:false,
      selectedWebhook:undefined,
      userSelected: undefined,
      contactSelected: undefined,
      isRegisterLoading: false,
      isRemoveModalOpened: false,
      toast: defaultToastAlert,
      form: new Form(this.generateForm("",  "","", false,"")),
      webhookForm : new Form(this.generateWebhookForm(this.props.subscriber?.label || "",this.props.subscriber?.clientId || "",this.props.subscriber?.webhookUrl || "",this.props.subscriber?.clientSecret || "",false)),
      showPassword:false,
    };
  }
  private handleTogglePassword = () =>{
    this.setState({ showPassword:!this.state.showPassword,webhookForm:new Form(this.generateWebhookForm(this.state.webhookForm.getFormField((UpdateWebhook.LABEL))?.value?.toString() ?? "",this.state.webhookForm.getFormField((UpdateWebhook.CLIENT_ID))?.value?.toString() ?? "",this.state.webhookForm.getFormField((UpdateWebhook.WEBHOOK_URL))?.value?.toString() ?? "",this.state.webhookForm.getFormField((UpdateWebhook.CLIENT_SECRET))?.value?.toString() ??"",this.state.showPassword)) });
  }
  private onToastHide = () => {
    this.setState({ toast: defaultToastAlert });
  };
  private generateForm(givenName: string,familyName: string, email: string, isPrimary: boolean,roleType:string) {
    return [
      new FormField(AddNewUser.GIVEN_NAME, givenName, {
        label: "clientSettings.addNewUser.field.givenName",
        placeholder: "clientSettings.addNewUser.field.givenName",
        isMandatory: true,
      }),
      new FormField(AddNewUser.FAMILY_NAME, familyName, {
        label: "clientSettings.addNewUser.field.familyName",
        placeholder: "clientSettings.addNewUser.field.familyName",
        isMandatory: true,
      }),
      new FormField(
        AddNewUser.Email_Address,
        email,
        {
          label: "clientSettings.addNewUser.field.email",
          placeholder:
            "clientSettings.addNewUser.field.email",
          isMandatory: true,
        },
        EFieldType.EMAIL
      ),
      new FormField(
        AddNewUser.isPrimaryUser,
        isPrimary,
        {
          label: "clientSettings.addNewUser.field.isPrimary",
          isMandatory: false,
        },
        EFieldType.CHECKBOX
      ),
      new FormField(
        AddNewContact.isPrimary,
        isPrimary,
        {
          label: "clientSettings.addNewContact.field.isPrimary",
          isMandatory: false,
        },
        EFieldType.CHECKBOX
      ),
      new FormField(
        AddNewContact.CONTACT_TYPE,
        roleType==""?roleTypes[0].name:roleType,
        {
          label: "clientSettings.addNewContact.field.role",
          placeholder: "clientSettings.addNewContact.field.role",
          isMandatory: false,
        },
        EFieldType.SELECT
      )
    ];
  }
  private generateWebhookForm(label :string, clientId :string, webhookUrl :string, clientSecret :string,showPassword:boolean){
    return [
      new FormField(UpdateWebhook.LABEL, label, {
        label: "clientSettings.updateWebhook.field.label",
        placeholder: "clientSettings.updateWebhook.field.label",
        isMandatory: true,
      }),
      new FormField(UpdateWebhook.CLIENT_ID, clientId, {
        label: "clientSettings.updateWebhook.field.clientId",
        placeholder: "clientSettings.updateWebhook.field.clientId",
        isMandatory: true,
      }),
      new FormField(
        UpdateWebhook.WEBHOOK_URL,
        webhookUrl,
        {
          label: "clientSettings.updateWebhook.field.webhookUrl",
          placeholder:
            "clientSettings.updateWebhook.field.webhookUrl",
          isMandatory: true,
        }
      ),
      new FormField(
        UpdateWebhook.CLIENT_SECRET,
        clientSecret,
        {
          label: "clientSettings.updateWebhook.field.clientSecret",
          placeholder:
            "clientSettings.updateWebhook.field.clientSecret",
          isMandatory: true,
        },showPassword?EFieldType.PASSWORD:EFieldType.VISIBLEPASSWORD
      )
    ]
  }
  private verifyField = (
    id: TFormInputId,
    hasPreviousError: boolean,
    isOnChange = false,
    additionalParams: IInputAdditionalParams = {}
  ) => {
    const form =this.state.form;
    form.updateFormFieldError(
      id,
      hasPreviousError,
      isOnChange,
      additionalParams
    );
    this.setState({ form });
  };
  private onChange = (
    id: TFormInputId,
    value: string | boolean,
    additionalParams: IInputAdditionalParams = {}
  ) => {
    const form = this.state.form;
    const previousFieldState = form.fields.find((el) => el.id === id);

    if (previousFieldState) {
      form.updateFormField({ id, value });
      this.setState({ form }, () =>
        this.verifyField(
          id,
          !!previousFieldState.options.error,
          true,
          additionalParams
        )
      );
    }
  };

  private submitForm() {
    const userPost = new UserPostCreation(this.state.form, this.props.user?.clientName, this.props.user?.clientName, this.props.user?.clientId, statuses.CREATEUSERFROMPORTAL);

    UserAPI.postUserCreation(userPost)
      .then(() => {
        let user = new User({ givenName: userPost.givenName, familyName: userPost.familyName, email: userPost.email, clientRequestName: userPost.clientRequestName, status: statuses.APPROVED,main: userPost.main});
        this.toastTimer();
        this.setState({
          isRegisterLoading: false,
          isModalOpened: false,
          isAddNewModalOpened: false,
          toast: {
            isDisplayed: true,
            type : ToastType.SUCCESS,
            message : <>User created successfully</>
          },
          listUsers: [...this.state.listUsers, user]
        });
      })
      .catch((error) => {
        let type = ToastType.ERROR;
        let message;

        switch (error.response.status) {
          case HttpCode.FORBIDDEN:
            message = <FormattedMessage id="unauthorized" />;
            break;

          case HttpCode.NOT_FOUND:
            message = <FormattedMessage id="clientNotFound" />;
            break;

          case HttpCode.CONFLICT:
            type = ToastType.WARNING;
            message = <FormattedMessage id="signUp.alreadyRegistered" />;
            break;

          default:
            message = <FormattedMessage id="signUp.registrationError" />;
            break;
        }
        this.toastTimer();
        this.setState({
          isRegisterLoading: false,
          toast: {
            isDisplayed: true,
            type,
            message,
          },
        });
      });
  }

  private submitContactForm() {
      const contactFound = this.state.listContacts.find(contact => contact.email === this.state.form.getFormField((AddNewUser.Email_Address))?.value+"");
      if(contactFound!=null){
        const type = ToastType.WARNING;
        const message = <FormattedMessage id="signUp.alreadyRegistered" />;
        this.setState({
          toast: {
            isDisplayed: true,
            type,
            message,
          },
        });
        return;
      }
    
    const contact = new Contact({name:this.state.form.getFormField(AddNewUser.GIVEN_NAME)?.value+" "+this.state.form.getFormField(AddNewUser.FAMILY_NAME)?.value,email: this.state.form.getFormField(AddNewUser.Email_Address)?.value,role:this.state.form.getFormField(AddNewContact.CONTACT_TYPE)?.value,primary:this.state.form.getFormField(AddNewContact.isPrimary)?.value});
    ClientSettingsAPI.updateContactsByClient(this.props.user?.clientId,[...this.state.listContacts, contact])
      .then(()=>{
        this.toastTimer();
        this.setState({
          isRegisterLoading: false,
          isModalOpened: false,
          isAddNewModalOpened: false,
          listContacts: [...this.state.listContacts, contact],
          toast: {
            isDisplayed: true,
            type : ToastType.SUCCESS,
            message : <>Contact created successfully</>
          },
        });
      })
      .catch((error) => {
        this.toastTimer();
        this.toastError("Error on contact creation, Please contact support");
      });
  }
  private toastError=(message:string)=>{
    this.setState({
      isRegisterLoading: false,
      toast: {
        isDisplayed: true,
        type : ToastType.ERROR,
        message : <>{message}</>
      },
    });
  }

  private toastTimer = ()=>{
    setTimeout(() => {
      this.setState({
      toast: {
        isDisplayed: false,
        type : ToastType.SUCCESS,
        message : <></>
      }
    });
    }, 3000);
  }

  private removeUser = (status: string,isForm :boolean, userObject: any,toastMessage?:string) => {
    let action="";
    let user = new User({
      givenName: userObject.givenName,
      familyName: userObject.familyName,
      clientRequestName: this.props.user?.clientRequestName || "", status: status,
      main:this.state.form.getFormField((AddNewUser.isPrimaryUser))?.value,
      email: userObject.email, clientId: this.props.user?.clientId
    });
    console.log(user);
    UserAPI.updateUser(user)
      .then(() => {
        if (status == statuses.REMOVECLIENTID){
          this.toastTimer();
          this.setState({
            isRegisterLoading: false,
            isModalOpened: false,
            toast: {
              isDisplayed: true,
              type : ToastType.SUCCESS,
              message : <>User removed successfully</>
            },
            isRemoveModalOpened: false,
            listUsers: this.state.listUsers.filter(user => user.email !== this.state.userSelected?.email)
          });
        }
        else if (status == statuses.APPROVED) {
          this.toastTimer();
          this.setState({
            isRegisterLoading: false,
            toast: {
              isDisplayed: true,
              type : ToastType.SUCCESS,
              message : <>{toastMessage}</>
            },
            isModalOpened: false,
            isUpdateModalOpened: false,
            isRegistartionApproved: false,
            listUsers: this.state.listUsers.map(user => {
              if (user.email === this.state.userSelected?.email) {
                if(isForm)
                return {
                  ...user, // Keep other properties unchanged
                  givenName: this.state.form.getFormField((AddNewUser.GIVEN_NAME))?.value, // Update the "name" property to a new value
                  familyName: this.state.form.getFormField((AddNewUser.FAMILY_NAME))?.value,
                  email: this.state.form.getFormField((AddNewUser.Email_Address))?.value,
                  status: statuses.APPROVED,
                  main:this.state.form.getFormField((AddNewUser.isPrimaryUser))?.value
                };
                else
                  return{
                    ...user,
                    status:statuses.APPROVED
                  }
              }
              return user; // Leave other objects unchanged
            })
          });
        }
        else if (status == statuses.REJECTED) {
          this.toastTimer();
          this.setState({
            isRegisterLoading: false,
            isModalOpened: false,
            toast: {
              isDisplayed: true,
              type : ToastType.SUCCESS,
              message : <>User rejected successfully</>
            },
            isRegistrationRejected: false,
            listUsers: this.state.listUsers.map(user => {
              if (user.email === this.state.userSelected?.email) {
                // Update the desired property, for example, updating the "name" property
                return {
                  ...user, // Keep other properties unchanged
                  
                  status: statuses.REJECTED
                };
              }
              return user; // Leave other objects unchanged
            })

          });
        }
      })
      .catch((error) => {
        this.toastTimer();
        if (status == statuses.REMOVECLIENTID){
          action="removal";
          this.setState({
            isRegisterLoading: false,
            isModalOpened: false
          });
        }
        else if (status == statuses.REJECTED)
          action="rejection";
        else if (status == statuses.APPROVED) 
          if(isForm)
            action="update";
          else action="approval";
        this.toastError("Error on user "+action+",please contact support");
      });
  }

  private updateWebhook = ()=>{
    if (this.isFormValid()){
    let subscriber = new SubscriberConfiguration({
      label: this.state.webhookForm.getFormField((UpdateWebhook.LABEL))?.value,
      clientId: this.state.webhookForm.getFormField((UpdateWebhook.CLIENT_ID))?.value,
      webhookUrl: this.state.webhookForm.getFormField((UpdateWebhook.WEBHOOK_URL))?.value,
      clientSecret:this.state.webhookForm.getFormField((UpdateWebhook.CLIENT_SECRET))?.value
    });
    ClientSettingsAPI.updateSubscriberConfiguration(subscriber).then((response)=>{
      this.toastTimer();
      this.setState({
        toast: {
        isDisplayed: true,
        type : ToastType.SUCCESS,
        message : <>Webhook Updated Successfully!</>
      }})
    })
    .catch((error) => {
      this.toastTimer();
      this.setState({
        isRegisterLoading: false,
        toast: {
          isDisplayed: true,
          type:ToastType.ERROR,
          message:<>Error. Please Try again!</>,
        },
      });
    });
    }
  }

  private updateContact = () => {
    if (!this.isFormValid())
      return;
    let newContactList = this.state.listContacts.map(contact => {
      if (contact.email === this.state.contactSelected?.email) {
        // Update the desired property, for example, updating the "name" property
        return {
          ...contact, // Keep other properties unchanged
          name: this.state.form.getFormField((AddNewUser.GIVEN_NAME))?.value+" "+ this.state.form.getFormField((AddNewUser.FAMILY_NAME))?.value??'', // Update the "name" property to a new value
          email: this.state.form.getFormField((AddNewUser.Email_Address))?.value+"",
          primary:this.state.form.getFormField((AddNewContact.isPrimary))?.value===true?true:false,
          role:this.state.form.getFormField((AddNewContact.CONTACT_TYPE))?.value as string
        };
      }
      return contact; // Leave other objects unchanged
    });
    ClientSettingsAPI.updateContactsByClient(this.props.user?.clientId,
      newContactList
    )
      .then(()=>{
        this.toastTimer();
        this.setState({
          isRegisterLoading: false,
          toast: {
            isDisplayed: true,
            type : ToastType.SUCCESS,
            message : <>Contact updated successfully</>
          },
          isModalOpened: false,
          isAddNewModalOpened: false,
          listContacts: newContactList
        });
      })
      .catch((error) => {
        this.toastTimer();
        this.toastError("Error on contact update, please contact support");
      });
  }
  private removeContact = () =>{
    let filteredContactList = this.state.listContacts.filter(contact => contact.email !== this.state.contactSelected?.email)
    if(filteredContactList.length==0){
      const type = ToastType.WARNING;
        const message = <FormattedMessage id="clientSettings.updateContact.message" />;
        this.setState({
          toast: {
            isDisplayed: true,
            type,
            message,
          },
        });
        return;
      
    }
    ClientSettingsAPI.updateContactsByClient(this.props.user?.clientId,
      filteredContactList
    )
      .then(()=>{
        this.toastTimer();
        this.setState({
          isRegisterLoading: false,
          toast: {
            isDisplayed: true,
            type : ToastType.SUCCESS,
            message : <>Contact removed successfully</>
          },
          isModalOpened: false,
          isAddNewModalOpened: false,
          listContacts: filteredContactList
        });
      })
      .catch((error) => {
        this.setState({
          isRegisterLoading: false,
          isModalOpened: false,
          isAddNewModalOpened: false
        });
        this.toastTimer();
        this.toastError("Error on contact removal, please contact support");
      });
  }

  private onConfirmClick = (param:string) => {
    this.setState({
      isRegisterLoading: true,
    });
    if (this.isFormValid()){
      if(param === "user")
        this.submitForm();
      else this.submitContactForm();
    }
    this.setState({
      isRegisterLoading: false,
    });
  }
  private isFormValid = (): boolean => {
    const form = this.state.form;
    const isFormValid = form.isFormValid();
    this.setState({ form });
    return isFormValid;
  };
  private onBlur = (id: TFormInputId) => {
    const form = this.state.form;
    const previousFieldState = form.fields.find(
      (el) => el.id === id
    );

    if (previousFieldState) {
      this.verifyField(id, !!previousFieldState.options.error);
    }
  };

  private getInput(
    id: TFormInputId,
    additionalParams: IInputAdditionalParams = {}
  ): JSX.Element | null {
    const field = this.state.form.getFormField(id);
    if (field) {
      return FormUtils.getInput(
        field,
        this.onChange,
        this.onBlur,
        false,
        additionalParams,
        
        this.handleTogglePassword
      );
    }
    return null;
  }
  componentDidMount() {
    ClientSettingsAPI.getMatchedUsersForClient().then((listUsers) =>
      this.setState({ listUsers })
    );
    ClientSettingsAPI.getContactsByClient().then((listContacts) =>
      this.setState({ listContacts })
    );

    if (this.props.namePart === ProfilePart.API_CREDENTIALS) {
      ClientSettingsAPI.getClientSecretRequests().then((clientSecretRequests) => {
        this.setState({ clientSecretRequests })
      });
    }
  }

  private openPart = () => {
    const partOpened = !this.state.partOpened;
    this.setState({ partOpened });
  };

  private displayContent = () => {
    let content;
    switch (this.props.namePart) {
      case ProfilePart.DETAILS:
        content = this.displayDetailsContent();
        break;
      case ProfilePart.COMMERCIAL_SUBSCRIPTION:
        content = this.displayCommercialSubscriptionContent();
        break;
      case ProfilePart.USERS_MANAGEMENT:
        content = this.displayUsersManagementContent();
        break;
      case ProfilePart.API_CREDENTIALS:
        content = this.displayApiCredentialsContent();
        break;
      case ProfilePart.EVENT_WEBHOOK:
        content = this.displayEventWebhook();
        break;
    }
    return content;
  };


  private displayApiCredentialsContent = () => {
    if (!!this.props.applications && this.props.applications.length > 0 && !!this.state.clientSecretRequests) {
      let arr: ApplicationsSecretMapping = {};
      this.state.clientSecretRequests?.forEach((request: ClientSecretRequest) => arr = { ...arr, [request.applicationName]: request });
      return this.props.applications.map((element: IApplication, key) => {
        if (!element.credentials.auth2Credentials)
          return;
        else if (arr[element.name]) {
          return <ApiCredentialsContent key={key} application={element} clientSecretRequest={arr[element.name]} />
        }
        else
          return <ApiCredentialsContent key={key} application={element} clientSecretRequest={new ClientSecretRequest({})} />
      })
    }
    else
      return <Loader />;
  }
  private displayEventWebhook = () => {
    return (<div className="users-management-content">
      <div className="map-div">
      {this.props.subscriber?.deliveryChannels.map((element,index)=>{
      return(<div className={`line ${index % 2 === 0 ? "even" : ""}`} key={index}>
        <Visibility onClick={()=>this.setState({selectedWebhook:element})} style={{ float: "right",paddingTop: "15px"  }} />
        <div className="name">
          {`Webhook ${index+1} - `}{element.default && 'Default'}
        </div>
        <div className="email">
          {`Mappers: ${element.mapper.map(mapper => mapper).join(', ')}`}
        </div>
      </div>);
      })}
      </div>
    </div>
    );
  }
  private displayDetailsContent = () => {
    return (
      <div className="details-content">
        <div className="clientRequestName">
          {this.props.user!.clientRequestName}
        </div>
        <div className="clientAddress">{this.displayAddress()}</div>
        <div className="title">
          <FormattedMessage id="clientSettings.title" />
        </div>
        <div className="contacts-content">
          {this.props.user!.clientRepresentativeName} -{" "}
          <a>{this.props.user!.clientRepresentativeEmail}</a>
        </div>
      </div>
    );
  };

  private displayAddress = () => {
    let address = this.props.user!.clientAddress.addressLine1;
    if (this.props.user!.clientAddress.addressLine2 !== "")
      address += ` ${this.props.user!.clientAddress.addressLine2}`;
    address += ` - ${this.props.user!.clientAddress.zipCode} ${this.props.user!.clientAddress.city
      } -`;
    address += ` ${this.props.user!.clientAddress.country}`;
    return address;
  };

  private displayCommercialSubscriptionContent = () => {
    return undefined;
  };

  private toggleDeleteProfilePopUpVisibility = (isDeleteProfilePopupVisible: boolean): void => {
    this.setState({ isDeleteProfilePopupVisible });
  };

  private displayUsersManagementContent =  () => {
    return (
      <div className="users-management-content">
        {this.props.user?.main && (this.state.listUsers !== undefined ? (
          this.state.listUsers.filter(user => user.status === statuses.PENDING).length > 0 ? (
            <>
              <div className="title">
                <FormattedMessage id="clientSettings.pendingUsers" />

              </div>
              <div className="map-div">
                {this.state.listUsers.filter(user => user.status === statuses.PENDING).map((user, index) =>
                  this.displayLineByUser(user, index, false)
                )}
              </div>
            </>
          ) : null
        ) : (
          <>
            <div className="title">
              <FormattedMessage id="clientSettings.pendingUsers" />
            </div>
            <Loader />
          </>)
        )}
        {this.state.listUsers !== undefined ? (
          this.state.listUsers.length > 0 ? (
            <>
              <div className="title">
                <FormattedMessage id="clientSettings.activeUsers" />
                {this.props.user?.main &&
                <svg onClick={(event) => this.setState({ isModalOpened: true, isAddNewModalOpened: true, isAddNewUserModal:true,form:new Form(this.generateForm("", "", "", false,"")) })} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ float: "right", marginTop: "3px" }}>
                  <path d="M8 4.5C8.25 4.5 8.45001 4.68 8.49001 4.91V5V7.5H10.99C11.27 7.5 11.49 7.72 11.49 8C11.49 8.25 11.31 8.45 11.08 8.49H10.99H8.49001V10.99C8.49001 11.27 8.27001 11.49 7.99001 11.49C7.74001 11.49 7.54 11.31 7.5 11.08V10.99V8.49H5C4.72 8.49 4.5 8.27 4.5 7.99C4.5 7.74 4.68 7.54 4.91 7.5H5H7.5V5C7.5 4.72 7.72 4.5 8 4.5ZM8 1C4.13 1 1 4.13 1 8C1 11.87 4.13 15 8 15C11.87 15 15 11.87 15 8C15 4.13 11.87 1 8 1ZM8 0C12.42 0 16 3.58 16 8C16 12.42 12.42 16 8 16C3.58 16 0 12.42 0 8C0 3.58 3.58 0 8 0Z" fill="#E20101"></path>
                </svg>}
              </div>
              <div className="map-div">
                {this.state.listUsers.filter(user => user.status === statuses.APPROVED).map((user, index) =>
                  this.displayLineByUser(user, index, true)
                )}
              </div>
            </>
          ) : null
        ) : (
          <>
            <div className="title">
              <FormattedMessage id="clientSettings.activeUsers" />
            </div>
            <Loader />
          </>
        )}
        {this.state.listContacts !== undefined ? (
          this.state.listContacts.length > 0 ? (
            <>
              <div className="title">
                <FormattedMessage id="clientSettings.activeContacts" />
                {this.props.user?.main && <svg onClick={(event) => this.setState({ isModalOpened: true, isAddNewModalOpened: true, isAddNewUserModal:false,form:new Form(this.generateForm("", "", "", false,"")) })} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ float: "right", marginTop: "3px" }}>
                  <path d="M8 4.5C8.25 4.5 8.45001 4.68 8.49001 4.91V5V7.5H10.99C11.27 7.5 11.49 7.72 11.49 8C11.49 8.25 11.31 8.45 11.08 8.49H10.99H8.49001V10.99C8.49001 11.27 8.27001 11.49 7.99001 11.49C7.74001 11.49 7.54 11.31 7.5 11.08V10.99V8.49H5C4.72 8.49 4.5 8.27 4.5 7.99C4.5 7.74 4.68 7.54 4.91 7.5H5H7.5V5C7.5 4.72 7.72 4.5 8 4.5ZM8 1C4.13 1 1 4.13 1 8C1 11.87 4.13 15 8 15C11.87 15 15 11.87 15 8C15 4.13 11.87 1 8 1ZM8 0C12.42 0 16 3.58 16 8C16 12.42 12.42 16 8 16C3.58 16 0 12.42 0 8C0 3.58 3.58 0 8 0Z" fill="#E20101"></path>
                </svg>}
              </div>
              <div className="map-div">
                {this.state.listContacts.length > 0 && this.state.listContacts.map((contact, index) =>
                  this.displayLineByContact(contact, index)
                )}
              </div>
            </>
          ) : null
        ) : (
          <>
            <div className="title">
              <FormattedMessage id="clientSettings.activeContacts" />
            </div>
            <Loader />
          </>
        )}
        <div className="title">
          <FormattedMessage id="clientSettings.myAccount" />
        </div>
        <div className="danger-zone" onClick={() => this.toggleDeleteProfilePopUpVisibility(true)}>
          <FormattedMessage id="deleteUser.profile" />
        </div>
        <DeleteProfilePopup user={{givenName:this.props.user?.givenName,familyName:this.props.user?.familyName.split("{")[0],email:this.props.user?.email,main:this.props.user?.main}} isDeleteProfilePopupVisible={this.state.isDeleteProfilePopupVisible} closeDeleteProfilePopUp={() => this.toggleDeleteProfilePopUpVisibility(false)} />
      </div>
    );
  };

  private displayLineByUser = (user: User, index: number, isPending: boolean) => {
    return (
      <div className={`line ${index % 2 === 0 ? "even" : ""}`}>
        <div>
          {isPending ?
            (this.props.user?.main && this.props.user?.email!==user.email && <svg style={{ float: "right", paddingTop: "15px" }} width="16" height="16" onClick={(event) => { let selectedUser = new User({ main:user.main,givenName: user.givenName, familyName: user.familyName, clientId: user.clientId, email: user.email }); this.setState({ isModalOpened: true,isAddNewUserModal:true, isUpdateModalOpened: true, userSelected: selectedUser,contactSelected:undefined, form: new Form(this.generateForm(user.givenName, user.familyName, user.email, user.main,"")) }) }} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12.15 1.15006L11.21 2.09006L13.5 4.38006L14.44 3.44006C14.61 3.27006 14.63 3.00006 14.5 2.80006L14.44 2.73006L12.85 1.14006C12.65 0.940059 12.34 0.940059 12.14 1.14006L12.15 1.15006ZM10.5 2.80006L3.20999 10.0901L5.49999 12.3801L12.79 5.09006L10.5 2.80006ZM2.67999 10.9701L1.39999 14.1801L4.60999 12.8901L2.67999 10.9601V10.9701ZM2.10999 9.77006L2.12999 9.74006L11.44 0.440059C12.03 -0.149941 12.98 -0.149941 13.56 0.440059L15.15 2.03006C15.74 2.62006 15.74 3.57006 15.15 4.15006L5.84999 13.4501C5.84999 13.4501 5.81999 13.4701 5.80999 13.4801L5.77999 13.5001L5.73999 13.5201H5.71999C5.71999 13.5201 5.70999 13.5301 5.69999 13.5401H5.68999L0.689993 15.5501C0.279993 15.7101 -0.120007 15.3101 0.0399926 14.9001L2.03999 9.90006C2.03999 9.90006 2.05999 9.86006 2.06999 9.84006C2.06999 9.83006 2.07999 9.82006 2.08999 9.81006L2.10999 9.78006V9.77006Z" fill="#3159ED" />
            </svg>)
            : (
              <span style={{ float: "right", paddingTop: "15px" }}>
                {this.props.user?.main && <svg onClick={(event) => { let selectedUser = new User({ main:user.main,givenName: user.givenName, familyName: user.familyName, clientId: user.clientId, email: user.email });this.setState({ isModalOpened: true, isRegistartionApproved: false,isRegistrationRejected:true, userSelected: selectedUser,contactSelected:undefined }) }} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10.99 7.5C11.27 7.5 11.49 7.72 11.49 8C11.49 8.25 11.31 8.45 11.08 8.49H10.99C8.99334 8.49 6.99667 8.49 5 8.49C4.72 8.49 4.5 8.27 4.5 7.99C4.5 7.74 4.68 7.54 4.91 7.5H5C6.99667 7.5 8.99334 7.5 10.99 7.5ZM8 1C4.13 1 1 4.13 1 8C1 11.87 4.13 15 8 15C11.87 15 15 11.87 15 8C15 4.13 11.87 1 8 1ZM8 0C12.42 0 16 3.58 16 8C16 12.42 12.42 16 8 16C3.58 16 0 12.42 0 8C0 3.58 3.58 0 8 0Z" fill="#3159ED" />
                </svg>}
                &nbsp;&nbsp;&nbsp;
                {this.props.user?.main && <svg onClick={(event) => { let selectedUser = new User({ main:user.main,givenName: user.givenName, familyName: user.familyName, clientId: user.clientId, email: user.email }); this.setState({ isModalOpened: true, isRegistartionApproved: true,isRegistrationRejected:false, userSelected: selectedUser,contactSelected:undefined }) }} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8 4.5C8.25 4.5 8.45001 4.68 8.49001 4.91V5V7.5H10.99C11.27 7.5 11.49 7.72 11.49 8C11.49 8.25 11.31 8.45 11.08 8.49H10.99H8.49001V10.99C8.49001 11.27 8.27001 11.49 7.99001 11.49C7.74001 11.49 7.54 11.31 7.5 11.08V10.99V8.49H5C4.72 8.49 4.5 8.27 4.5 7.99C4.5 7.74 4.68 7.54 4.91 7.5H5H7.5V5C7.5 4.72 7.72 4.5 8 4.5ZM8 1C4.13 1 1 4.13 1 8C1 11.87 4.13 15 8 15C11.87 15 15 11.87 15 8C15 4.13 11.87 1 8 1ZM8 0C12.42 0 16 3.58 16 8C16 12.42 12.42 16 8 16C3.58 16 0 12.42 0 8C0 3.58 3.58 0 8 0Z" fill="#3159ED" />
                </svg>}

              </span>
            )}

        </div>
        <div className="name">
          <div className="family-name">{user.familyName}</div>
          <div className="family-name">{user.givenName}</div>
        </div>
        <div className="email">{user.email} &nbsp;&nbsp;
        {this.props.user?.main && user.main &&<svg style={{paddingBottom:"10px"}}  width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.22965 0C7.61965 0 8.01965 0.03 8.40965 0.1C8.67965 0.14 8.85965 0.4 8.81965 0.67C8.77965 0.94 8.51965 1.12 8.25965 1.07C7.91965 1.02 7.57965 0.99 7.23965 0.99C4.90965 0.99 2.77965 2.27 1.68965 4.33C1.59965 4.49 1.43965 4.59 1.25965 4.59C1.17965 4.59 1.09965 4.57 1.02965 4.53C0.789652 4.4 0.699652 4.11 0.819652 3.87C2.06965 1.48 4.52965 0 7.22965 0ZM0.569652 6.01H0.589652C0.859652 6.04 1.05965 6.28 1.02965 6.55L1.00965 6.71C0.899652 7.95 1.15965 9.18 1.74965 10.26C1.87965 10.5 1.78965 10.8 1.54965 10.93C1.45965 10.98 1.36965 11 1.26965 10.99C1.10965 10.98 0.959652 10.88 0.879652 10.74C0.199652 9.47 -0.100348 8.05 0.0296518 6.62L0.0496518 6.45C0.0796518 6.18 0.309652 6.01 0.569652 6.01ZM10.4897 0.77L10.7297 0.9C13.0497 2.18 14.4797 4.59 14.4797 7.25C14.4797 8.87 13.9597 10.4 12.9697 11.68C12.8797 11.8 12.7297 11.87 12.5797 11.87C12.4697 11.87 12.3697 11.83 12.2797 11.77C12.0597 11.6 12.0197 11.3 12.1897 11.08C13.0397 9.97 13.4997 8.65 13.4997 7.25C13.4997 4.87 12.1797 2.72 10.0497 1.65C9.80965 1.53 9.70965 1.23 9.82965 0.99C9.94965 0.75 10.2497 0.65 10.4897 0.77ZM2.61965 11.5L2.81965 11.71C3.98965 12.86 5.57965 13.52 7.22965 13.52C8.54965 13.52 9.80965 13.11 10.8797 12.35C11.0997 12.19 11.4097 12.24 11.5697 12.46C11.7297 12.68 11.6797 12.99 11.4597 13.15C10.2197 14.04 8.75965 14.51 7.22965 14.51C5.20965 14.51 3.26965 13.66 1.89965 12.17C1.71965 11.97 1.72965 11.66 1.92965 11.48C2.12965 11.29 2.43965 11.31 2.62965 11.51L2.61965 11.5ZM4.77965 3.82C4.22965 4.51 4.10965 5.4 4.21965 6.27C4.07965 6.42 4.00965 6.6 3.98965 6.78C3.92965 7.27 4.22965 7.74 4.67965 8.18C4.71965 8.96 4.95965 9.56 5.26965 10C5.18965 10.33 4.83965 10.66 4.31965 10.95C4.11965 11.06 3.90965 11.15 3.71965 11.22L3.57965 11.27L3.49965 11.3C3.28965 11.41 3.17965 11.66 3.24965 11.89C3.31965 12.1 3.50965 12.24 3.72965 12.24C3.77965 12.24 3.82965 12.24 3.87965 12.22C4.00965 12.18 4.20965 12.11 4.44965 12C5.54965 11.5 6.28965 10.8 6.28965 9.85C6.28965 9.75 6.25965 9.66 6.20965 9.58L6.09965 9.45L6.03965 9.36L5.95965 9.22L5.88965 9.07L5.82965 8.91C5.72965 8.63 5.67965 8.32 5.67965 7.96C5.67965 7.81 5.61965 7.68 5.50965 7.58C5.27965 7.39 5.05965 7.1 4.99965 6.96V6.94L5.06965 6.9C5.21965 6.79 5.29965 6.59 5.25965 6.4V6.31L5.21965 6.02C5.19965 5.72 5.21965 5.4 5.29965 5.1C5.36965 4.85 5.46965 4.63 5.61965 4.44C5.93965 4.04 6.47965 3.83 7.23965 3.83H7.43965C8.09965 3.87 8.56965 4.07 8.86965 4.44C9.01965 4.62 9.11965 4.84 9.18965 5.1C9.28965 5.47 9.29965 5.87 9.24965 6.24L9.22965 6.4V6.48C9.20965 6.67 9.31965 6.85 9.49965 6.94V6.97C9.42965 7.11 9.20965 7.39 8.98965 7.58C8.87965 7.67 8.81965 7.81 8.81965 7.96C8.81965 8.13 8.80965 8.3 8.77965 8.45C8.75965 8.57 8.72965 8.69 8.69965 8.79L8.65965 8.91C8.55965 9.2 8.42965 9.4 8.33965 9.5C8.24965 9.59 8.19965 9.72 8.19965 9.85C8.19965 10.01 8.21965 10.16 8.26965 10.31L8.31965 10.44V10.42C8.58965 11.11 9.18965 11.6 9.98965 11.97C10.1397 12.04 10.2897 12.1 10.4197 12.15L10.6097 12.22C10.6597 12.24 10.7097 12.24 10.7597 12.24C10.9797 12.24 11.1697 12.1 11.2397 11.89C11.3197 11.63 11.1697 11.35 10.9097 11.26L10.7797 11.21L10.5197 11.11C10.4097 11.06 10.2997 11.01 10.1797 10.95C9.64965 10.66 9.29965 10.33 9.21965 10C9.38965 9.76 9.54965 9.44 9.65965 9.06L9.70965 8.88L9.75965 8.65C9.78965 8.5 9.79965 8.34 9.80965 8.18C10.2597 7.74 10.5597 7.27 10.4997 6.78C10.4797 6.6 10.3997 6.42 10.2697 6.27C10.3797 5.4 10.2597 4.52 9.70965 3.82C9.17965 3.15 8.34965 2.82 7.25965 2.82C6.16965 2.82 5.33965 3.15 4.80965 3.82H4.77965Z" fill="#596591"></path>
        </svg>}
        </div>
      </div>
    );
  };

  private displayLineByContact = (contact: Contact, index: number) => {
    return (
      <div className={`line ${index % 2 === 0 ? "even" : ""}`}>
        <div className="name">
          <div className="family-name">{contact.name}</div>
        </div>
        <div>
          {this.props.user?.main && <svg width="16" height="16" style={{ float: "right",  }} onClick={(event) =>{ let selectedContact = new Contact({ name: contact.name, email:contact.email, role:contact.role, primary:contact.primary }); this.setState({ isModalOpened: true, isUpdateModalOpened: true,isAddNewUserModal:false, contactSelected: selectedContact,userSelected:undefined, form: new Form(this.generateForm(contact.name.split(" ")[0], contact.name.split(" ")[1]??'', contact.email, contact.primary,contact.role)) })}} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.15 1.15006L11.21 2.09006L13.5 4.38006L14.44 3.44006C14.61 3.27006 14.63 3.00006 14.5 2.80006L14.44 2.73006L12.85 1.14006C12.65 0.940059 12.34 0.940059 12.14 1.14006L12.15 1.15006ZM10.5 2.80006L3.20999 10.0901L5.49999 12.3801L12.79 5.09006L10.5 2.80006ZM2.67999 10.9701L1.39999 14.1801L4.60999 12.8901L2.67999 10.9601V10.9701ZM2.10999 9.77006L2.12999 9.74006L11.44 0.440059C12.03 -0.149941 12.98 -0.149941 13.56 0.440059L15.15 2.03006C15.74 2.62006 15.74 3.57006 15.15 4.15006L5.84999 13.4501C5.84999 13.4501 5.81999 13.4701 5.80999 13.4801L5.77999 13.5001L5.73999 13.5201H5.71999C5.71999 13.5201 5.70999 13.5301 5.69999 13.5401H5.68999L0.689993 15.5501C0.279993 15.7101 -0.120007 15.3101 0.0399926 14.9001L2.03999 9.90006C2.03999 9.90006 2.05999 9.86006 2.06999 9.84006C2.06999 9.83006 2.07999 9.82006 2.08999 9.81006L2.10999 9.78006V9.77006Z" fill="#3159ED" />
          </svg>}

        </div>
        <div className="email">{contact.email} &nbsp;&nbsp;
        {this.props.user?.main && contact.primary && <svg style={{paddingBottom:"10px"}}  width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.22965 0C7.61965 0 8.01965 0.03 8.40965 0.1C8.67965 0.14 8.85965 0.4 8.81965 0.67C8.77965 0.94 8.51965 1.12 8.25965 1.07C7.91965 1.02 7.57965 0.99 7.23965 0.99C4.90965 0.99 2.77965 2.27 1.68965 4.33C1.59965 4.49 1.43965 4.59 1.25965 4.59C1.17965 4.59 1.09965 4.57 1.02965 4.53C0.789652 4.4 0.699652 4.11 0.819652 3.87C2.06965 1.48 4.52965 0 7.22965 0ZM0.569652 6.01H0.589652C0.859652 6.04 1.05965 6.28 1.02965 6.55L1.00965 6.71C0.899652 7.95 1.15965 9.18 1.74965 10.26C1.87965 10.5 1.78965 10.8 1.54965 10.93C1.45965 10.98 1.36965 11 1.26965 10.99C1.10965 10.98 0.959652 10.88 0.879652 10.74C0.199652 9.47 -0.100348 8.05 0.0296518 6.62L0.0496518 6.45C0.0796518 6.18 0.309652 6.01 0.569652 6.01ZM10.4897 0.77L10.7297 0.9C13.0497 2.18 14.4797 4.59 14.4797 7.25C14.4797 8.87 13.9597 10.4 12.9697 11.68C12.8797 11.8 12.7297 11.87 12.5797 11.87C12.4697 11.87 12.3697 11.83 12.2797 11.77C12.0597 11.6 12.0197 11.3 12.1897 11.08C13.0397 9.97 13.4997 8.65 13.4997 7.25C13.4997 4.87 12.1797 2.72 10.0497 1.65C9.80965 1.53 9.70965 1.23 9.82965 0.99C9.94965 0.75 10.2497 0.65 10.4897 0.77ZM2.61965 11.5L2.81965 11.71C3.98965 12.86 5.57965 13.52 7.22965 13.52C8.54965 13.52 9.80965 13.11 10.8797 12.35C11.0997 12.19 11.4097 12.24 11.5697 12.46C11.7297 12.68 11.6797 12.99 11.4597 13.15C10.2197 14.04 8.75965 14.51 7.22965 14.51C5.20965 14.51 3.26965 13.66 1.89965 12.17C1.71965 11.97 1.72965 11.66 1.92965 11.48C2.12965 11.29 2.43965 11.31 2.62965 11.51L2.61965 11.5ZM4.77965 3.82C4.22965 4.51 4.10965 5.4 4.21965 6.27C4.07965 6.42 4.00965 6.6 3.98965 6.78C3.92965 7.27 4.22965 7.74 4.67965 8.18C4.71965 8.96 4.95965 9.56 5.26965 10C5.18965 10.33 4.83965 10.66 4.31965 10.95C4.11965 11.06 3.90965 11.15 3.71965 11.22L3.57965 11.27L3.49965 11.3C3.28965 11.41 3.17965 11.66 3.24965 11.89C3.31965 12.1 3.50965 12.24 3.72965 12.24C3.77965 12.24 3.82965 12.24 3.87965 12.22C4.00965 12.18 4.20965 12.11 4.44965 12C5.54965 11.5 6.28965 10.8 6.28965 9.85C6.28965 9.75 6.25965 9.66 6.20965 9.58L6.09965 9.45L6.03965 9.36L5.95965 9.22L5.88965 9.07L5.82965 8.91C5.72965 8.63 5.67965 8.32 5.67965 7.96C5.67965 7.81 5.61965 7.68 5.50965 7.58C5.27965 7.39 5.05965 7.1 4.99965 6.96V6.94L5.06965 6.9C5.21965 6.79 5.29965 6.59 5.25965 6.4V6.31L5.21965 6.02C5.19965 5.72 5.21965 5.4 5.29965 5.1C5.36965 4.85 5.46965 4.63 5.61965 4.44C5.93965 4.04 6.47965 3.83 7.23965 3.83H7.43965C8.09965 3.87 8.56965 4.07 8.86965 4.44C9.01965 4.62 9.11965 4.84 9.18965 5.1C9.28965 5.47 9.29965 5.87 9.24965 6.24L9.22965 6.4V6.48C9.20965 6.67 9.31965 6.85 9.49965 6.94V6.97C9.42965 7.11 9.20965 7.39 8.98965 7.58C8.87965 7.67 8.81965 7.81 8.81965 7.96C8.81965 8.13 8.80965 8.3 8.77965 8.45C8.75965 8.57 8.72965 8.69 8.69965 8.79L8.65965 8.91C8.55965 9.2 8.42965 9.4 8.33965 9.5C8.24965 9.59 8.19965 9.72 8.19965 9.85C8.19965 10.01 8.21965 10.16 8.26965 10.31L8.31965 10.44V10.42C8.58965 11.11 9.18965 11.6 9.98965 11.97C10.1397 12.04 10.2897 12.1 10.4197 12.15L10.6097 12.22C10.6597 12.24 10.7097 12.24 10.7597 12.24C10.9797 12.24 11.1697 12.1 11.2397 11.89C11.3197 11.63 11.1697 11.35 10.9097 11.26L10.7797 11.21L10.5197 11.11C10.4097 11.06 10.2997 11.01 10.1797 10.95C9.64965 10.66 9.29965 10.33 9.21965 10C9.38965 9.76 9.54965 9.44 9.65965 9.06L9.70965 8.88L9.75965 8.65C9.78965 8.5 9.79965 8.34 9.80965 8.18C10.2597 7.74 10.5597 7.27 10.4997 6.78C10.4797 6.6 10.3997 6.42 10.2697 6.27C10.3797 5.4 10.2597 4.52 9.70965 3.82C9.17965 3.15 8.34965 2.82 7.25965 2.82C6.16965 2.82 5.33965 3.15 4.80965 3.82H4.77965Z" fill="#596591"></path>
        </svg>}</div>
        {/* <ContactRole key={index} id={index} role={contact.role} /> */}
      </div>
    );
  };


  private getAddNewModal() {
    return (
      <div id="new-customer" className="success App-content">
        {this.state.toast.isDisplayed && (
          <ToastAlert
            toastType={this.state.toast.type}
            toastMessage={this.state.toast.message}
            hideToast={this.onToastHide}
            className="toast"
          />
        )}
        <div className="title">
          {this.state.isAddNewUserModal ? (<FormattedMessage id="clientSettings.addNewUser.label" />)
          :(<FormattedMessage id="clientSettings.addNewContact.label" />)}
          <svg onClick={(event) => this.setState({ isModalOpened: false, isAddNewModalOpened: false })} width="12" height="13" viewBox="0 0 12 13" fill="none" style={{ float: "right", marginTop: "3px" }} xmlns="http://www.w3.org/2000/svg">
            <path d="M0.850234 0.65L5.80023 5.6L10.7502 0.65C10.9502 0.45 11.2602 0.45 11.4602 0.65C11.6602 0.85 11.6602 1.16 11.4602 1.36L6.51023 6.3L11.4602 11.25C11.6602 11.45 11.6602 11.76 11.4602 11.96C11.2602 12.16 10.9502 12.16 10.7502 11.96L5.80023 7.01L0.850234 11.96C0.650234 12.16 0.340234 12.16 0.140234 11.96C-0.0597656 11.76 -0.0597656 11.45 0.140234 11.25L5.10023 6.3L0.150234 1.35C-0.0497656 1.16 -0.0497656 0.84 0.150234 0.65C0.340234 0.45 0.660234 0.45 0.850234 0.65Z" fill="#0A2071" />
          </svg>
        </div>

        {this.getInput(AddNewUser.GIVEN_NAME)}
        {this.getInput(AddNewUser.FAMILY_NAME)}
        {this.getInput(AddNewUser.Email_Address)}
        {!this.state.isAddNewUserModal && this.getInput(AddNewContact.CONTACT_TYPE,{
              selectItems: roleTypes,
            })}
        {this.state.isAddNewUserModal?this.getInput(AddNewUser.isPrimaryUser):this.getInput(AddNewContact.isPrimary)}
        <div className="buttons-container">
          {this.state.isRegisterLoading ? (
            <Loader />
          ) : (
            <Button className="button" onClick={()=>{if(this.state.isAddNewUserModal) 
            this.onConfirmClick("user") 
            else this.onConfirmClick("contact") }}>
              {this.state.isAddNewUserModal ? (<FormattedMessage id="clientSettings.addNewUser.button.create" />)
          :(<FormattedMessage id="clientSettings.addNewContact.button.create" />)}
            </Button>
          )}

        </div>
      </div>
    );
  }
  private getAuthenticationUI(element?: DeliveryChannel) {
    switch (element?.authenticationType) {
      case authenticationType.BASIC_AUTH:
        return (
          <div className="authentication-container">
            <div>
              <span className="authentication-label">
                <FormattedMessage id="clientSettings.updateWebhook.form.username" />
              </span>
              <span>
                : {(element.authenticationDetail as Basic)?.username}
              </span>
            </div>
          </div>
        );
      case authenticationType.OAUTH:
        return (
          <div className="authentication-container">
            <div>
              <span className="authentication-label">
                <FormattedMessage id="clientSettings.updateWebhook.form.authUrl" />
              </span>
              <span>
                : {(element.authenticationDetail as OAuth2)?.authUrl}
              </span>
            </div>
            <div>
              <span className="authentication-label">
                <FormattedMessage id="clientSettings.updateWebhook.form.clientId" />
              </span>
              <span>
                : {(element.authenticationDetail as OAuth2)?.clientId}
              </span>
            </div>
            <div>
              <span className="authentication-label">
                <FormattedMessage id="clientSettings.updateWebhook.form.clientSecret" />
              </span>
              <span>
                : {"**********"}
              </span>
            </div>
            <div>
              <span className="authentication-label">
                <FormattedMessage id="clientSettings.updateWebhook.form.scope" />
              </span>
              <span>
                : {(element.authenticationDetail as OAuth2)?.scope}
              </span>
            </div>
          </div>
        );
      case authenticationType.APIKEY:
        return (
          <div className="authentication-container">
            <div>
              <span className="authentication-label">
                <FormattedMessage id="clientSettings.updateWebhook.form.apiKeyHeaderName" />
              </span>
            <span>
              : {(element.authenticationDetail as ApiKey)?.apiKeyHeaderName}
            </span>
          </div>
            <div>
              <span className="authentication-label">
                <FormattedMessage id="clientSettings.updateWebhook.form.apiKeyValue" />
              </span>
              <span>
                : {"**********"}
              </span>
            </div>
          </div>
        );
      default:
        return null;
    }
  }
  private getUpdateWebhookModal(){
    return (
      <div id="new-customer" className="success App-content">
        {this.state.toast.isDisplayed && (
          <ToastAlert
            toastType={this.state.toast.type}
            toastMessage={this.state.toast.message}
            hideToast={this.onToastHide}
          />
        )}
        <div className="title">
          <FormattedMessage id="clientSettings.updateWebhook.label" />
          <svg onClick={(event) => this.setState({ selectedWebhook: undefined})} width="12" height="13" viewBox="0 0 12 13" fill="none" style={{ float: "right", marginTop: "3px" }} xmlns="http://www.w3.org/2000/svg">
            <path d="M0.850234 0.65L5.80023 5.6L10.7502 0.65C10.9502 0.45 11.2602 0.45 11.4602 0.65C11.6602 0.85 11.6602 1.16 11.4602 1.36L6.51023 6.3L11.4602 11.25C11.6602 11.45 11.6602 11.76 11.4602 11.96C11.2602 12.16 10.9502 12.16 10.7502 11.96L5.80023 7.01L0.850234 11.96C0.650234 12.16 0.340234 12.16 0.140234 11.96C-0.0597656 11.76 -0.0597656 11.45 0.140234 11.25L5.10023 6.3L0.150234 1.35C-0.0497656 1.16 -0.0497656 0.84 0.150234 0.65C0.340234 0.45 0.660234 0.45 0.850234 0.65Z" fill="#0A2071" />
          </svg>
        </div>

        <div>
  <b className="webhook-header">
    {`Webhook ${this.state.selectedWebhook?.index} - `}
    {this.state.selectedWebhook?.default && <span style={{ color: 'green' }}><FormattedMessage id="clientSettings.updateWebhook.form.default" /></span>}
  </b>
  <br />
  <span className="webhook-mappers">
    {`Mappers: ${this.state.selectedWebhook?.mapper.join(', ')}`}
  </span>
  <div className="webhook-url">
    <span><b><FormattedMessage id="clientSettings.updateWebhook.form.webhookUrl" />: </b></span><br />
      {this.state.selectedWebhook?.endpoint}
  </div>
  <div className="authentication-type">
    <span><FormattedMessage id="clientSettings.updateWebhook.form.authenticationType" />: </span>
    <b>{this.state.selectedWebhook?.authenticationType}</b>
  </div>

  {this.getAuthenticationUI(this.state.selectedWebhook)}
</div>
      </div>
    );
  }

  private getUpdateUserModal() {
    return (
      <div id="new-customer" className="success App-content">
        {this.state.toast.isDisplayed && (
          <ToastAlert
            toastType={this.state.toast.type}
            toastMessage={this.state.toast.message}
            hideToast={this.onToastHide}
          />
        )}
        <div className="title">
          {this.state.userSelected!==undefined?<FormattedMessage id="clientSettings.updateUser.label" />
          :<FormattedMessage id="clientSettings.updateContact.label" />
    }
          <svg onClick={(event) => this.setState({ isModalOpened: false, isUpdateModalOpened: false })} width="12" height="13" viewBox="0 0 12 13" fill="none" style={{ float: "right", marginTop: "3px" }} xmlns="http://www.w3.org/2000/svg">
            <path d="M0.850234 0.65L5.80023 5.6L10.7502 0.65C10.9502 0.45 11.2602 0.45 11.4602 0.65C11.6602 0.85 11.6602 1.16 11.4602 1.36L6.51023 6.3L11.4602 11.25C11.6602 11.45 11.6602 11.76 11.4602 11.96C11.2602 12.16 10.9502 12.16 10.7502 11.96L5.80023 7.01L0.850234 11.96C0.650234 12.16 0.340234 12.16 0.140234 11.96C-0.0597656 11.76 -0.0597656 11.45 0.140234 11.25L5.10023 6.3L0.150234 1.35C-0.0497656 1.16 -0.0497656 0.84 0.150234 0.65C0.340234 0.45 0.660234 0.45 0.850234 0.65Z" fill="#0A2071" />
          </svg>
        </div>

        {this.getInput(AddNewUser.GIVEN_NAME)}
        {this.getInput(AddNewUser.FAMILY_NAME)}
        {this.state.userSelected===undefined?this.getInput(AddNewUser.Email_Address,{disabled:false}):this.getInput(AddNewUser.Email_Address,{disabled:true})}
        
        {this.state.userSelected===undefined && this.getInput(AddNewContact.CONTACT_TYPE,{
              selectItems: roleTypes,
            })}
        {this.state.userSelected!==undefined?(this.getInput(AddNewUser.isPrimaryUser)):(this.getInput(AddNewContact.isPrimary))}
        <div className="buttons-container">
          <Button className="button inverted" onClick={()=>this.setState({ isModalOpened: false, isUpdateModalOpened: false })}>
            <FormattedMessage id="clientSettings.updateUser.button.cancelModifications" />
          </Button>
          <Button className="button blue" style={{ backgroundColor: "#0A2071", border: "none" }} onClick={(event) => { this.setState({ isModalOpened: true, isUpdateModalOpened: false, isRemoveModalOpened: true }) }}>
            {this.state.userSelected!==undefined?
              <FormattedMessage id="clientSettings.updateUser.button.removeUserFromClient" />
            :<FormattedMessage id="clientSettings.updateContact.button.removeContactFromClient" />}
          </Button>
          <Button className="button" onClick={(event) => { 
            if(this.state.isAddNewUserModal){
              if (this.isFormValid())
                this.removeUser(statuses.APPROVED,true, { familyName: this.state.form.getFormField((AddNewUser.FAMILY_NAME))?.value, givenName: this.state.form.getFormField((AddNewUser.GIVEN_NAME))?.value, email: this.state.form.getFormField((AddNewUser.Email_Address))?.value },"User updated successfully")}
            else this.updateContact()
          }}>
            <FormattedMessage id="clientSettings.updateUser.button.saveModifications" />
          </Button>
        </div>
      </div>
    );
  }


  
  private getRemoveUserModal() {
    return (
      <div id="new-customer" className="success App-content">
        <div className="title">
          {this.state.userSelected!==undefined?<FormattedMessage id="clientSettings.removeUser.label" />
          :<FormattedMessage id="clientSettings.removeContact.label" />
          }
          <svg onClick={(event) => this.setState({ isModalOpened: false, isRemoveModalOpened: false })} width="12" height="13" viewBox="0 0 12 13" fill="none" style={{ float: "right", marginTop: "3px" }} xmlns="http://www.w3.org/2000/svg">
            <path d="M0.850234 0.65L5.80023 5.6L10.7502 0.65C10.9502 0.45 11.2602 0.45 11.4602 0.65C11.6602 0.85 11.6602 1.16 11.4602 1.36L6.51023 6.3L11.4602 11.25C11.6602 11.45 11.6602 11.76 11.4602 11.96C11.2602 12.16 10.9502 12.16 10.7502 11.96L5.80023 7.01L0.850234 11.96C0.650234 12.16 0.340234 12.16 0.140234 11.96C-0.0597656 11.76 -0.0597656 11.45 0.140234 11.25L5.10023 6.3L0.150234 1.35C-0.0497656 1.16 -0.0497656 0.84 0.150234 0.65C0.340234 0.45 0.660234 0.45 0.850234 0.65Z" fill="#0A2071" />
          </svg>
        </div>
        <div style={{ marginLeft: "10px" }}><span className="name">{this.state.userSelected!==undefined?this.state.userSelected?.givenName:this.state.contactSelected?.name}</span> <span className="name">{this.state.userSelected!==undefined?this.state.userSelected?.familyName:""}</span><br />
          <span className="email">{this.state.userSelected!==undefined?this.state.userSelected?.email:this.state.contactSelected?.email}</span> &nbsp;&nbsp;&nbsp;&nbsp;
          {
          this.state.userSelected!==undefined?
          this.state.userSelected?.main &&<svg style={{ marginTop: "-40px" }} width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.22965 0C7.61965 0 8.01965 0.03 8.40965 0.1C8.67965 0.14 8.85965 0.4 8.81965 0.67C8.77965 0.94 8.51965 1.12 8.25965 1.07C7.91965 1.02 7.57965 0.99 7.23965 0.99C4.90965 0.99 2.77965 2.27 1.68965 4.33C1.59965 4.49 1.43965 4.59 1.25965 4.59C1.17965 4.59 1.09965 4.57 1.02965 4.53C0.789652 4.4 0.699652 4.11 0.819652 3.87C2.06965 1.48 4.52965 0 7.22965 0ZM0.569652 6.01H0.589652C0.859652 6.04 1.05965 6.28 1.02965 6.55L1.00965 6.71C0.899652 7.95 1.15965 9.18 1.74965 10.26C1.87965 10.5 1.78965 10.8 1.54965 10.93C1.45965 10.98 1.36965 11 1.26965 10.99C1.10965 10.98 0.959652 10.88 0.879652 10.74C0.199652 9.47 -0.100348 8.05 0.0296518 6.62L0.0496518 6.45C0.0796518 6.18 0.309652 6.01 0.569652 6.01ZM10.4897 0.77L10.7297 0.9C13.0497 2.18 14.4797 4.59 14.4797 7.25C14.4797 8.87 13.9597 10.4 12.9697 11.68C12.8797 11.8 12.7297 11.87 12.5797 11.87C12.4697 11.87 12.3697 11.83 12.2797 11.77C12.0597 11.6 12.0197 11.3 12.1897 11.08C13.0397 9.97 13.4997 8.65 13.4997 7.25C13.4997 4.87 12.1797 2.72 10.0497 1.65C9.80965 1.53 9.70965 1.23 9.82965 0.99C9.94965 0.75 10.2497 0.65 10.4897 0.77ZM2.61965 11.5L2.81965 11.71C3.98965 12.86 5.57965 13.52 7.22965 13.52C8.54965 13.52 9.80965 13.11 10.8797 12.35C11.0997 12.19 11.4097 12.24 11.5697 12.46C11.7297 12.68 11.6797 12.99 11.4597 13.15C10.2197 14.04 8.75965 14.51 7.22965 14.51C5.20965 14.51 3.26965 13.66 1.89965 12.17C1.71965 11.97 1.72965 11.66 1.92965 11.48C2.12965 11.29 2.43965 11.31 2.62965 11.51L2.61965 11.5ZM4.77965 3.82C4.22965 4.51 4.10965 5.4 4.21965 6.27C4.07965 6.42 4.00965 6.6 3.98965 6.78C3.92965 7.27 4.22965 7.74 4.67965 8.18C4.71965 8.96 4.95965 9.56 5.26965 10C5.18965 10.33 4.83965 10.66 4.31965 10.95C4.11965 11.06 3.90965 11.15 3.71965 11.22L3.57965 11.27L3.49965 11.3C3.28965 11.41 3.17965 11.66 3.24965 11.89C3.31965 12.1 3.50965 12.24 3.72965 12.24C3.77965 12.24 3.82965 12.24 3.87965 12.22C4.00965 12.18 4.20965 12.11 4.44965 12C5.54965 11.5 6.28965 10.8 6.28965 9.85C6.28965 9.75 6.25965 9.66 6.20965 9.58L6.09965 9.45L6.03965 9.36L5.95965 9.22L5.88965 9.07L5.82965 8.91C5.72965 8.63 5.67965 8.32 5.67965 7.96C5.67965 7.81 5.61965 7.68 5.50965 7.58C5.27965 7.39 5.05965 7.1 4.99965 6.96V6.94L5.06965 6.9C5.21965 6.79 5.29965 6.59 5.25965 6.4V6.31L5.21965 6.02C5.19965 5.72 5.21965 5.4 5.29965 5.1C5.36965 4.85 5.46965 4.63 5.61965 4.44C5.93965 4.04 6.47965 3.83 7.23965 3.83H7.43965C8.09965 3.87 8.56965 4.07 8.86965 4.44C9.01965 4.62 9.11965 4.84 9.18965 5.1C9.28965 5.47 9.29965 5.87 9.24965 6.24L9.22965 6.4V6.48C9.20965 6.67 9.31965 6.85 9.49965 6.94V6.97C9.42965 7.11 9.20965 7.39 8.98965 7.58C8.87965 7.67 8.81965 7.81 8.81965 7.96C8.81965 8.13 8.80965 8.3 8.77965 8.45C8.75965 8.57 8.72965 8.69 8.69965 8.79L8.65965 8.91C8.55965 9.2 8.42965 9.4 8.33965 9.5C8.24965 9.59 8.19965 9.72 8.19965 9.85C8.19965 10.01 8.21965 10.16 8.26965 10.31L8.31965 10.44V10.42C8.58965 11.11 9.18965 11.6 9.98965 11.97C10.1397 12.04 10.2897 12.1 10.4197 12.15L10.6097 12.22C10.6597 12.24 10.7097 12.24 10.7597 12.24C10.9797 12.24 11.1697 12.1 11.2397 11.89C11.3197 11.63 11.1697 11.35 10.9097 11.26L10.7797 11.21L10.5197 11.11C10.4097 11.06 10.2997 11.01 10.1797 10.95C9.64965 10.66 9.29965 10.33 9.21965 10C9.38965 9.76 9.54965 9.44 9.65965 9.06L9.70965 8.88L9.75965 8.65C9.78965 8.5 9.79965 8.34 9.80965 8.18C10.2597 7.74 10.5597 7.27 10.4997 6.78C10.4797 6.6 10.3997 6.42 10.2697 6.27C10.3797 5.4 10.2597 4.52 9.70965 3.82C9.17965 3.15 8.34965 2.82 7.25965 2.82C6.16965 2.82 5.33965 3.15 4.80965 3.82H4.77965Z" fill="#596591" />
          </svg>
          :this.state.contactSelected?.primary &&
          <svg style={{ marginTop: "-40px" }} width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.22965 0C7.61965 0 8.01965 0.03 8.40965 0.1C8.67965 0.14 8.85965 0.4 8.81965 0.67C8.77965 0.94 8.51965 1.12 8.25965 1.07C7.91965 1.02 7.57965 0.99 7.23965 0.99C4.90965 0.99 2.77965 2.27 1.68965 4.33C1.59965 4.49 1.43965 4.59 1.25965 4.59C1.17965 4.59 1.09965 4.57 1.02965 4.53C0.789652 4.4 0.699652 4.11 0.819652 3.87C2.06965 1.48 4.52965 0 7.22965 0ZM0.569652 6.01H0.589652C0.859652 6.04 1.05965 6.28 1.02965 6.55L1.00965 6.71C0.899652 7.95 1.15965 9.18 1.74965 10.26C1.87965 10.5 1.78965 10.8 1.54965 10.93C1.45965 10.98 1.36965 11 1.26965 10.99C1.10965 10.98 0.959652 10.88 0.879652 10.74C0.199652 9.47 -0.100348 8.05 0.0296518 6.62L0.0496518 6.45C0.0796518 6.18 0.309652 6.01 0.569652 6.01ZM10.4897 0.77L10.7297 0.9C13.0497 2.18 14.4797 4.59 14.4797 7.25C14.4797 8.87 13.9597 10.4 12.9697 11.68C12.8797 11.8 12.7297 11.87 12.5797 11.87C12.4697 11.87 12.3697 11.83 12.2797 11.77C12.0597 11.6 12.0197 11.3 12.1897 11.08C13.0397 9.97 13.4997 8.65 13.4997 7.25C13.4997 4.87 12.1797 2.72 10.0497 1.65C9.80965 1.53 9.70965 1.23 9.82965 0.99C9.94965 0.75 10.2497 0.65 10.4897 0.77ZM2.61965 11.5L2.81965 11.71C3.98965 12.86 5.57965 13.52 7.22965 13.52C8.54965 13.52 9.80965 13.11 10.8797 12.35C11.0997 12.19 11.4097 12.24 11.5697 12.46C11.7297 12.68 11.6797 12.99 11.4597 13.15C10.2197 14.04 8.75965 14.51 7.22965 14.51C5.20965 14.51 3.26965 13.66 1.89965 12.17C1.71965 11.97 1.72965 11.66 1.92965 11.48C2.12965 11.29 2.43965 11.31 2.62965 11.51L2.61965 11.5ZM4.77965 3.82C4.22965 4.51 4.10965 5.4 4.21965 6.27C4.07965 6.42 4.00965 6.6 3.98965 6.78C3.92965 7.27 4.22965 7.74 4.67965 8.18C4.71965 8.96 4.95965 9.56 5.26965 10C5.18965 10.33 4.83965 10.66 4.31965 10.95C4.11965 11.06 3.90965 11.15 3.71965 11.22L3.57965 11.27L3.49965 11.3C3.28965 11.41 3.17965 11.66 3.24965 11.89C3.31965 12.1 3.50965 12.24 3.72965 12.24C3.77965 12.24 3.82965 12.24 3.87965 12.22C4.00965 12.18 4.20965 12.11 4.44965 12C5.54965 11.5 6.28965 10.8 6.28965 9.85C6.28965 9.75 6.25965 9.66 6.20965 9.58L6.09965 9.45L6.03965 9.36L5.95965 9.22L5.88965 9.07L5.82965 8.91C5.72965 8.63 5.67965 8.32 5.67965 7.96C5.67965 7.81 5.61965 7.68 5.50965 7.58C5.27965 7.39 5.05965 7.1 4.99965 6.96V6.94L5.06965 6.9C5.21965 6.79 5.29965 6.59 5.25965 6.4V6.31L5.21965 6.02C5.19965 5.72 5.21965 5.4 5.29965 5.1C5.36965 4.85 5.46965 4.63 5.61965 4.44C5.93965 4.04 6.47965 3.83 7.23965 3.83H7.43965C8.09965 3.87 8.56965 4.07 8.86965 4.44C9.01965 4.62 9.11965 4.84 9.18965 5.1C9.28965 5.47 9.29965 5.87 9.24965 6.24L9.22965 6.4V6.48C9.20965 6.67 9.31965 6.85 9.49965 6.94V6.97C9.42965 7.11 9.20965 7.39 8.98965 7.58C8.87965 7.67 8.81965 7.81 8.81965 7.96C8.81965 8.13 8.80965 8.3 8.77965 8.45C8.75965 8.57 8.72965 8.69 8.69965 8.79L8.65965 8.91C8.55965 9.2 8.42965 9.4 8.33965 9.5C8.24965 9.59 8.19965 9.72 8.19965 9.85C8.19965 10.01 8.21965 10.16 8.26965 10.31L8.31965 10.44V10.42C8.58965 11.11 9.18965 11.6 9.98965 11.97C10.1397 12.04 10.2897 12.1 10.4197 12.15L10.6097 12.22C10.6597 12.24 10.7097 12.24 10.7597 12.24C10.9797 12.24 11.1697 12.1 11.2397 11.89C11.3197 11.63 11.1697 11.35 10.9097 11.26L10.7797 11.21L10.5197 11.11C10.4097 11.06 10.2997 11.01 10.1797 10.95C9.64965 10.66 9.29965 10.33 9.21965 10C9.38965 9.76 9.54965 9.44 9.65965 9.06L9.70965 8.88L9.75965 8.65C9.78965 8.5 9.79965 8.34 9.80965 8.18C10.2597 7.74 10.5597 7.27 10.4997 6.78C10.4797 6.6 10.3997 6.42 10.2697 6.27C10.3797 5.4 10.2597 4.52 9.70965 3.82C9.17965 3.15 8.34965 2.82 7.25965 2.82C6.16965 2.82 5.33965 3.15 4.80965 3.82H4.77965Z" fill="#596591" />
          </svg>
          }
        </div>

        <div className="buttons-container">
          <Button className="button" style={{ backgroundColor: "#0A2071", border: "none" }} onClick={(event) =>
            {
              if(this.state.userSelected!==undefined)
                this.removeUser(statuses.REMOVECLIENTID,false, { familyName: this.state.form.getFormField((AddNewUser.FAMILY_NAME))?.value, givenName: this.state.form.getFormField((AddNewUser.GIVEN_NAME))?.value, email: this.state.form.getFormField((AddNewUser.Email_Address))?.value })
              else this.removeContact()
            }
          }>
            {this.state.userSelected!==undefined?<FormattedMessage id="clientSettings.removeUser.button.confirmUserRemoval" />
            :<FormattedMessage id="clientSettings.updateContact.button.removeContactFromClient" />
            }
          </Button>
        </div>
      </div>
    );
  }
  private getRegistrationRejectedModal(){
    return(<div id="new-customer" className="success App-content">
        <div className="title">
          <FormattedMessage id="clientSettings.rejectRegestrationRequest.label" />
          <svg onClick={(event) => this.setState({ isModalOpened: false, isRegistrationRejected: false })} width="12" height="13" viewBox="0 0 12 13" fill="none" style={{ float: "right", marginTop: "3px" }} xmlns="http://www.w3.org/2000/svg">
            <path d="M0.850234 0.65L5.80023 5.6L10.7502 0.65C10.9502 0.45 11.2602 0.45 11.4602 0.65C11.6602 0.85 11.6602 1.16 11.4602 1.36L6.51023 6.3L11.4602 11.25C11.6602 11.45 11.6602 11.76 11.4602 11.96C11.2602 12.16 10.9502 12.16 10.7502 11.96L5.80023 7.01L0.850234 11.96C0.650234 12.16 0.340234 12.16 0.140234 11.96C-0.0597656 11.76 -0.0597656 11.45 0.140234 11.25L5.10023 6.3L0.150234 1.35C-0.0497656 1.16 -0.0497656 0.84 0.150234 0.65C0.340234 0.45 0.660234 0.45 0.850234 0.65Z" fill="#0A2071" />
          </svg>
        </div>
        <div style={{ marginLeft: "10px" }}><span className="name">{this.state.userSelected?.givenName}</span> <span className="name">{this.state.userSelected?.familyName}</span><br />
          <span className="email">{this.state.userSelected?.email}</span> &nbsp;&nbsp;&nbsp;&nbsp;
          {this.state.userSelected?.main &&<svg style={{ marginTop: "-40px" }} width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.22965 0C7.61965 0 8.01965 0.03 8.40965 0.1C8.67965 0.14 8.85965 0.4 8.81965 0.67C8.77965 0.94 8.51965 1.12 8.25965 1.07C7.91965 1.02 7.57965 0.99 7.23965 0.99C4.90965 0.99 2.77965 2.27 1.68965 4.33C1.59965 4.49 1.43965 4.59 1.25965 4.59C1.17965 4.59 1.09965 4.57 1.02965 4.53C0.789652 4.4 0.699652 4.11 0.819652 3.87C2.06965 1.48 4.52965 0 7.22965 0ZM0.569652 6.01H0.589652C0.859652 6.04 1.05965 6.28 1.02965 6.55L1.00965 6.71C0.899652 7.95 1.15965 9.18 1.74965 10.26C1.87965 10.5 1.78965 10.8 1.54965 10.93C1.45965 10.98 1.36965 11 1.26965 10.99C1.10965 10.98 0.959652 10.88 0.879652 10.74C0.199652 9.47 -0.100348 8.05 0.0296518 6.62L0.0496518 6.45C0.0796518 6.18 0.309652 6.01 0.569652 6.01ZM10.4897 0.77L10.7297 0.9C13.0497 2.18 14.4797 4.59 14.4797 7.25C14.4797 8.87 13.9597 10.4 12.9697 11.68C12.8797 11.8 12.7297 11.87 12.5797 11.87C12.4697 11.87 12.3697 11.83 12.2797 11.77C12.0597 11.6 12.0197 11.3 12.1897 11.08C13.0397 9.97 13.4997 8.65 13.4997 7.25C13.4997 4.87 12.1797 2.72 10.0497 1.65C9.80965 1.53 9.70965 1.23 9.82965 0.99C9.94965 0.75 10.2497 0.65 10.4897 0.77ZM2.61965 11.5L2.81965 11.71C3.98965 12.86 5.57965 13.52 7.22965 13.52C8.54965 13.52 9.80965 13.11 10.8797 12.35C11.0997 12.19 11.4097 12.24 11.5697 12.46C11.7297 12.68 11.6797 12.99 11.4597 13.15C10.2197 14.04 8.75965 14.51 7.22965 14.51C5.20965 14.51 3.26965 13.66 1.89965 12.17C1.71965 11.97 1.72965 11.66 1.92965 11.48C2.12965 11.29 2.43965 11.31 2.62965 11.51L2.61965 11.5ZM4.77965 3.82C4.22965 4.51 4.10965 5.4 4.21965 6.27C4.07965 6.42 4.00965 6.6 3.98965 6.78C3.92965 7.27 4.22965 7.74 4.67965 8.18C4.71965 8.96 4.95965 9.56 5.26965 10C5.18965 10.33 4.83965 10.66 4.31965 10.95C4.11965 11.06 3.90965 11.15 3.71965 11.22L3.57965 11.27L3.49965 11.3C3.28965 11.41 3.17965 11.66 3.24965 11.89C3.31965 12.1 3.50965 12.24 3.72965 12.24C3.77965 12.24 3.82965 12.24 3.87965 12.22C4.00965 12.18 4.20965 12.11 4.44965 12C5.54965 11.5 6.28965 10.8 6.28965 9.85C6.28965 9.75 6.25965 9.66 6.20965 9.58L6.09965 9.45L6.03965 9.36L5.95965 9.22L5.88965 9.07L5.82965 8.91C5.72965 8.63 5.67965 8.32 5.67965 7.96C5.67965 7.81 5.61965 7.68 5.50965 7.58C5.27965 7.39 5.05965 7.1 4.99965 6.96V6.94L5.06965 6.9C5.21965 6.79 5.29965 6.59 5.25965 6.4V6.31L5.21965 6.02C5.19965 5.72 5.21965 5.4 5.29965 5.1C5.36965 4.85 5.46965 4.63 5.61965 4.44C5.93965 4.04 6.47965 3.83 7.23965 3.83H7.43965C8.09965 3.87 8.56965 4.07 8.86965 4.44C9.01965 4.62 9.11965 4.84 9.18965 5.1C9.28965 5.47 9.29965 5.87 9.24965 6.24L9.22965 6.4V6.48C9.20965 6.67 9.31965 6.85 9.49965 6.94V6.97C9.42965 7.11 9.20965 7.39 8.98965 7.58C8.87965 7.67 8.81965 7.81 8.81965 7.96C8.81965 8.13 8.80965 8.3 8.77965 8.45C8.75965 8.57 8.72965 8.69 8.69965 8.79L8.65965 8.91C8.55965 9.2 8.42965 9.4 8.33965 9.5C8.24965 9.59 8.19965 9.72 8.19965 9.85C8.19965 10.01 8.21965 10.16 8.26965 10.31L8.31965 10.44V10.42C8.58965 11.11 9.18965 11.6 9.98965 11.97C10.1397 12.04 10.2897 12.1 10.4197 12.15L10.6097 12.22C10.6597 12.24 10.7097 12.24 10.7597 12.24C10.9797 12.24 11.1697 12.1 11.2397 11.89C11.3197 11.63 11.1697 11.35 10.9097 11.26L10.7797 11.21L10.5197 11.11C10.4097 11.06 10.2997 11.01 10.1797 10.95C9.64965 10.66 9.29965 10.33 9.21965 10C9.38965 9.76 9.54965 9.44 9.65965 9.06L9.70965 8.88L9.75965 8.65C9.78965 8.5 9.79965 8.34 9.80965 8.18C10.2597 7.74 10.5597 7.27 10.4997 6.78C10.4797 6.6 10.3997 6.42 10.2697 6.27C10.3797 5.4 10.2597 4.52 9.70965 3.82C9.17965 3.15 8.34965 2.82 7.25965 2.82C6.16965 2.82 5.33965 3.15 4.80965 3.82H4.77965Z" fill="#596591" />
          </svg>}
        </div>

        <div className="buttons-container">
          <Button className="button" style={{ backgroundColor: "#0A2071", border: "none" }} onClick={(event) => { this.removeUser(statuses.REJECTED,false, { givenName: this.state.userSelected?.givenName, familyName: this.state.userSelected?.familyName, email: this.state.userSelected?.email }) }}>
            <FormattedMessage id="clientSettings.rejectRegestrationRequest.button" />
          </Button>
        </div>
      </div>)
  }
  private getRegistrationApprovedModal() {
    return (
      <div id="new-customer" className="success App-content">
        <div className="title">
          <FormattedMessage id="clientSettings.approveRegestrationRequest.label" />
          <svg onClick={(event) => this.setState({ isModalOpened: false, isRegistartionApproved: false })} width="12" height="13" viewBox="0 0 12 13" fill="none" style={{ float: "right", marginTop: "3px" }} xmlns="http://www.w3.org/2000/svg">
            <path d="M0.850234 0.65L5.80023 5.6L10.7502 0.65C10.9502 0.45 11.2602 0.45 11.4602 0.65C11.6602 0.85 11.6602 1.16 11.4602 1.36L6.51023 6.3L11.4602 11.25C11.6602 11.45 11.6602 11.76 11.4602 11.96C11.2602 12.16 10.9502 12.16 10.7502 11.96L5.80023 7.01L0.850234 11.96C0.650234 12.16 0.340234 12.16 0.140234 11.96C-0.0597656 11.76 -0.0597656 11.45 0.140234 11.25L5.10023 6.3L0.150234 1.35C-0.0497656 1.16 -0.0497656 0.84 0.150234 0.65C0.340234 0.45 0.660234 0.45 0.850234 0.65Z" fill="#0A2071" />
          </svg>
        </div>
        <div style={{ marginLeft: "10px" }}><span className="name">{this.state.userSelected?.givenName}</span> <span className="name">{this.state.userSelected?.familyName}</span><br />
          <span className="email">{this.state.userSelected?.email}</span> &nbsp;&nbsp;&nbsp;&nbsp;
          {this.state.userSelected?.main &&<svg style={{ marginTop: "-40px" }} width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.22965 0C7.61965 0 8.01965 0.03 8.40965 0.1C8.67965 0.14 8.85965 0.4 8.81965 0.67C8.77965 0.94 8.51965 1.12 8.25965 1.07C7.91965 1.02 7.57965 0.99 7.23965 0.99C4.90965 0.99 2.77965 2.27 1.68965 4.33C1.59965 4.49 1.43965 4.59 1.25965 4.59C1.17965 4.59 1.09965 4.57 1.02965 4.53C0.789652 4.4 0.699652 4.11 0.819652 3.87C2.06965 1.48 4.52965 0 7.22965 0ZM0.569652 6.01H0.589652C0.859652 6.04 1.05965 6.28 1.02965 6.55L1.00965 6.71C0.899652 7.95 1.15965 9.18 1.74965 10.26C1.87965 10.5 1.78965 10.8 1.54965 10.93C1.45965 10.98 1.36965 11 1.26965 10.99C1.10965 10.98 0.959652 10.88 0.879652 10.74C0.199652 9.47 -0.100348 8.05 0.0296518 6.62L0.0496518 6.45C0.0796518 6.18 0.309652 6.01 0.569652 6.01ZM10.4897 0.77L10.7297 0.9C13.0497 2.18 14.4797 4.59 14.4797 7.25C14.4797 8.87 13.9597 10.4 12.9697 11.68C12.8797 11.8 12.7297 11.87 12.5797 11.87C12.4697 11.87 12.3697 11.83 12.2797 11.77C12.0597 11.6 12.0197 11.3 12.1897 11.08C13.0397 9.97 13.4997 8.65 13.4997 7.25C13.4997 4.87 12.1797 2.72 10.0497 1.65C9.80965 1.53 9.70965 1.23 9.82965 0.99C9.94965 0.75 10.2497 0.65 10.4897 0.77ZM2.61965 11.5L2.81965 11.71C3.98965 12.86 5.57965 13.52 7.22965 13.52C8.54965 13.52 9.80965 13.11 10.8797 12.35C11.0997 12.19 11.4097 12.24 11.5697 12.46C11.7297 12.68 11.6797 12.99 11.4597 13.15C10.2197 14.04 8.75965 14.51 7.22965 14.51C5.20965 14.51 3.26965 13.66 1.89965 12.17C1.71965 11.97 1.72965 11.66 1.92965 11.48C2.12965 11.29 2.43965 11.31 2.62965 11.51L2.61965 11.5ZM4.77965 3.82C4.22965 4.51 4.10965 5.4 4.21965 6.27C4.07965 6.42 4.00965 6.6 3.98965 6.78C3.92965 7.27 4.22965 7.74 4.67965 8.18C4.71965 8.96 4.95965 9.56 5.26965 10C5.18965 10.33 4.83965 10.66 4.31965 10.95C4.11965 11.06 3.90965 11.15 3.71965 11.22L3.57965 11.27L3.49965 11.3C3.28965 11.41 3.17965 11.66 3.24965 11.89C3.31965 12.1 3.50965 12.24 3.72965 12.24C3.77965 12.24 3.82965 12.24 3.87965 12.22C4.00965 12.18 4.20965 12.11 4.44965 12C5.54965 11.5 6.28965 10.8 6.28965 9.85C6.28965 9.75 6.25965 9.66 6.20965 9.58L6.09965 9.45L6.03965 9.36L5.95965 9.22L5.88965 9.07L5.82965 8.91C5.72965 8.63 5.67965 8.32 5.67965 7.96C5.67965 7.81 5.61965 7.68 5.50965 7.58C5.27965 7.39 5.05965 7.1 4.99965 6.96V6.94L5.06965 6.9C5.21965 6.79 5.29965 6.59 5.25965 6.4V6.31L5.21965 6.02C5.19965 5.72 5.21965 5.4 5.29965 5.1C5.36965 4.85 5.46965 4.63 5.61965 4.44C5.93965 4.04 6.47965 3.83 7.23965 3.83H7.43965C8.09965 3.87 8.56965 4.07 8.86965 4.44C9.01965 4.62 9.11965 4.84 9.18965 5.1C9.28965 5.47 9.29965 5.87 9.24965 6.24L9.22965 6.4V6.48C9.20965 6.67 9.31965 6.85 9.49965 6.94V6.97C9.42965 7.11 9.20965 7.39 8.98965 7.58C8.87965 7.67 8.81965 7.81 8.81965 7.96C8.81965 8.13 8.80965 8.3 8.77965 8.45C8.75965 8.57 8.72965 8.69 8.69965 8.79L8.65965 8.91C8.55965 9.2 8.42965 9.4 8.33965 9.5C8.24965 9.59 8.19965 9.72 8.19965 9.85C8.19965 10.01 8.21965 10.16 8.26965 10.31L8.31965 10.44V10.42C8.58965 11.11 9.18965 11.6 9.98965 11.97C10.1397 12.04 10.2897 12.1 10.4197 12.15L10.6097 12.22C10.6597 12.24 10.7097 12.24 10.7597 12.24C10.9797 12.24 11.1697 12.1 11.2397 11.89C11.3197 11.63 11.1697 11.35 10.9097 11.26L10.7797 11.21L10.5197 11.11C10.4097 11.06 10.2997 11.01 10.1797 10.95C9.64965 10.66 9.29965 10.33 9.21965 10C9.38965 9.76 9.54965 9.44 9.65965 9.06L9.70965 8.88L9.75965 8.65C9.78965 8.5 9.79965 8.34 9.80965 8.18C10.2597 7.74 10.5597 7.27 10.4997 6.78C10.4797 6.6 10.3997 6.42 10.2697 6.27C10.3797 5.4 10.2597 4.52 9.70965 3.82C9.17965 3.15 8.34965 2.82 7.25965 2.82C6.16965 2.82 5.33965 3.15 4.80965 3.82H4.77965Z" fill="#596591" />
          </svg>}
        </div>

        <div className="buttons-container">
          <Button className="button"  onClick={(event) => { this.removeUser(statuses.APPROVED,false, { givenName: this.state.userSelected?.givenName, familyName: this.state.userSelected?.familyName, email: this.state.userSelected?.email },"User approved successfully") }}>
            <FormattedMessage id="clientSettings.approveRegestrationRequest.button" />
          </Button>
        </div>
      </div>
    );
  }
   

  private getEmpty() {
    return (
      <></>
    );
  }

  render() {

    let content;

    if (this.state.isAddNewModalOpened) {
      content = this.getAddNewModal();
    } else if (this.state.isUpdateModalOpened) {
      content = this.getUpdateUserModal();
    } else if (this.state.isRemoveModalOpened) {
      content = this.getRemoveUserModal();
    } else if (this.state.isRegistartionApproved) {
      content = this.getRegistrationApprovedModal();
    }else if(this.state.isRegistrationRejected){
      content = this.getRegistrationRejectedModal();
    } else {
      content = this.getEmpty();
    }
    return (
      <div className={this.props.namePart}>
        
        <div className="header" onClick={() => this.openPart()}>
          <BracedTitle
            text={
              <FormattedMessage id={`clientSettings.${this.props.namePart}`} />
            }
          />
          {this.state.toast.isDisplayed && !this.state.selectedWebhook && !this.state.isModalOpened &&(
          <ToastAlert
            toastType={this.state.toast.type}
            toastMessage={this.state.toast.message}
            hideToast={this.onToastHide}
            className="fixed-toast"
          />
        )}
          {this.state.partOpened ? (
            <KeyboardArrowUpIcon />
          ) : (
            <KeyboardArrowDownIcon />
          )}
        </div>
        {this.state.partOpened && (
          <div className="content">
            {this.displayContent()}
            <Modal open={this.state.isModalOpened}>
              <>
              {content}
              </>
            </Modal>
            <Modal open={this.state.selectedWebhook!==undefined}>
              <>
              {this.getUpdateWebhookModal()}
              </>
            </Modal>
          </div>
        )}
      </div>
    );
  }

}

const mapState = (state: IReducerState) => ({
  user: state.user,
  screenType: state.screenType,
});

const connector = connect(mapState, {});
export default connector(PartContent);
